module.exports = __webpack_public_path__ + "static/media/open.2b88d334.svg";